import { useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import MobileSearchTrigger from './Trigger';
import MobileSearchModal from './Modal';
import { getSearchQueryFromUrl } from '../../../helpers';

interface Props {
  toggle?: () => void;
}

const SearchMobile = ({ toggle }: Props) => {
  const [search, setSearch] = useState('');
  const [showSearchModal, setShowSearchModal] = useState(false);
  const preserveSearchRef = useRef(false);

  const router = useRouter();
  const qsQuery = router.query.query;
  const initialQuery =
    qsQuery != null && !Array.isArray(qsQuery) ? qsQuery : '';

  const preserveSearch = () => {
    preserveSearchRef.current = true;
  };

  useEffect(() => {
    setSearch(initialQuery || '');
  }, [initialQuery]);

  useEffect(() => {
    const closeModal = () => setShowSearchModal(false);

    // Reset the search bar to the destination page's query on navigation so it
    // never carries a previous page's text. Navigation triggered from the
    // search box itself (selecting a suggestion or submitting) keeps the typed
    // term, since the user searched their way to that page.
    const resetToUrl = (url: string) => {
      if (preserveSearchRef.current) {
        preserveSearchRef.current = false;

        return;
      }

      setSearch(getSearchQueryFromUrl(url));
    };

    const clearPreserve = () => {
      preserveSearchRef.current = false;
    };

    router.events.on('routeChangeStart', closeModal);
    router.events.on('routeChangeComplete', resetToUrl);
    router.events.on('routeChangeError', clearPreserve);

    return () => {
      router.events.off('routeChangeStart', closeModal);
      router.events.off('routeChangeComplete', resetToUrl);
      router.events.off('routeChangeError', clearPreserve);
    };
  }, [router.events]);

  return (
    <div className="sm:hidden">
      <MobileSearchTrigger
        setShowSearchModal={setShowSearchModal}
        search={search}
      />
      <MobileSearchModal
        setShowSearchModal={setShowSearchModal}
        showSearchModal={showSearchModal}
        toggle={toggle}
        search={search}
        setSearch={setSearch}
        onSearchNavigate={preserveSearch}
      />
    </div>
  );
};

export default SearchMobile;
